import { Inject, Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  GetAccountsResponse,
  BootstrapAccountPayload,
} from '../store/interfaces';

@Injectable()
export class MaService {
  constructor(
    private readonly http: HttpClient,
    @Inject('maBaseUrl') private url: string,
  ) {}

  getAccounts() {
    return this.http.get<GetAccountsResponse>(`${this.url}reports/accounts`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  bootstrap(payload: BootstrapAccountPayload) {
    return this.http.post<string>(`${this.url}bootstrap`, payload, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  checkActivity(activityId: string) {
    return this.http.get<string>(`${this.url}doctor/${activityId}`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  getFlowStatistics({
    type,
    period,
    length,
    report,
  }: {
    type: 'flows' | 'profiles';
    period?: 'month' | 'day';
    length?: number;
    report?: 'created' | 'active';
  }) {
    let queryString = period || length || report ? '?' : '';

    if (period) {
      queryString = `${queryString}&period=${period}`;
    }

    if (length) {
      queryString = `${queryString}&length=${length}`;
    }

    if (report) {
      queryString = `${queryString}&report=${report}`;
    }

    return this.http.get<string>(
      `${this.url}statistics/${type}${queryString}`,
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      },
    );
  }
}
